import { api } from './api';

const specialAuthorizationsGetList = async (customerId) => {
    const response = await api({
        url: `SpecialAuthorizations/getList`,
        method: 'GET',
        params: {
            customerId,
        },
    });
    return response.data;
};

const specialAuthorizationsUpdate = async (data) => {
    const response = await api({
        url: `SpecialAuthorizations/update`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const specialAuthorizationsServices = {
  specialAuthorizationsGetList,
  specialAuthorizationsUpdate,
};

export default specialAuthorizationsServices;
